var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_47",
    "data-name": "Komponente 10 \\u2013 47",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.768,
    height: 62,
    viewBox: "0 0 61.768 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target",
    transform: "translate(-0.956 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35373",
    "data-name": "Gruppe 35373",
    transform: "translate(15.575 17.092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35370",
    "data-name": "Gruppe 35370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35369",
    "data-name": "Gruppe 35369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46708",
    "data-name": "Pfad 46708",
    d: "M122.889,143.565a1.21,1.21,0,1,1,1.188-.974A1.22,1.22,0,0,1,122.889,143.565Z",
    transform: "translate(-121.681 -141.147)",
    fill: "#a5b5af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35372",
    "data-name": "Gruppe 35372",
    transform: "translate(22.129 24.866)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35371",
    "data-name": "Gruppe 35371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46709",
    "data-name": "Pfad 46709",
    d: "M305.637,348.912a1.21,1.21,0,1,1,1.2-1.021,1.222,1.222,0,0,1-1.2,1.021Z",
    transform: "translate(-304.427 -346.494)",
    fill: "#a5b5af"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35375",
    "data-name": "Gruppe 35375",
    transform: "translate(0.956 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35374",
    "data-name": "Gruppe 35374",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46710",
    "data-name": "Pfad 46710",
    d: "M62.649,9A1.211,1.211,0,0,0,61.6,8.216L55,7.722l-.494-6.6A1.211,1.211,0,0,0,52.444.355L47.168,5.632A4.862,4.862,0,0,0,45.742,8.9q0,.033,0,.066l.072,4.043a27.585,27.585,0,1,0,3.948,3.907l4,.065h.064a4.863,4.863,0,0,0,3.271-1.425L62.37,10.28A1.211,1.211,0,0,0,62.649,9ZM48.88,7.344l3.41-3.41.333,4.455-4.392,4.4-.068-3.826a2.447,2.447,0,0,1,.716-1.617ZM28.513,59.578a25.134,25.134,0,1,1,16.77-43.839l-2.8,2.8a21.154,21.154,0,0,0-21.142-4.02A1.211,1.211,0,1,0,22.16,16.8a18.736,18.736,0,0,1,18.6,3.458l-2.809,2.809a14.787,14.787,0,1,0-2.72,24.549,1.211,1.211,0,1,0-1.1-2.156,12.209,12.209,0,0,1-5.617,1.35,12.368,12.368,0,1,1,7.72-22.023l-2.825,2.825a8.418,8.418,0,1,0,1.745,1.68l2.814-2.814a12.356,12.356,0,0,1,2.288,11.855,1.211,1.211,0,0,0,2.3.764,14.778,14.778,0,0,0-2.869-14.336l2.805-2.805A18.751,18.751,0,1,1,13.36,23.41,1.211,1.211,0,0,0,11.4,21.982a21.175,21.175,0,1,0,32.8-1.739l2.8-2.8A25.121,25.121,0,0,1,28.513,59.578ZM34.5,34.445a5.99,5.99,0,1,1-2.835-5.086L27.8,33.221a1.211,1.211,0,1,0,1.712,1.712l3.908-3.908A5.951,5.951,0,0,1,34.5,34.445Zm20.882-20.6a2.448,2.448,0,0,1-1.618.716L49.949,14.5l2.326-2.326c.026-.026.05-.053.073-.08L54.337,10.1l4.454.333Z",
    transform: "translate(-0.956 -0.001)",
    fill: "#a5b5af"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.4a5e48a9cb4c015dd4b098405122dc09.svg";
export { ForwardRef as ReactComponent };